<template>
<div id="app">
<nav class="navbar slidepad" role="navigation">
  <div class="container-fluid" style="padding: 0;position: relative">
    <div class="navbar-header" style="margin: 0">
      <button type="button" class="navbar-toggle collapsed" data-toggle="collapse"
              data-target="#navbar-collapse-1" aria-expanded="false">
        <span class="sr-only">Toggle navigation</span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
      <a class="navbar-brand" href="/#/" style="margin-left: 0"><img src="./assets/logo.png" alt="" height="30"></a>
    </div>
    <div class="collapse navbar-collapse" id="navbar-collapse-1">
      <ul class="nav navbar-nav">
        <li>
          <a href="/#/" data-toggle="collapse" data-target="#navbar-collapse-1">
            Home
            <div class="tab"></div>
          </a>
        </li>
        <li class="dropdown">
          <a>
            Blockchain <b class="caret"></b>
            <div class="tab"></div>
          </a>
          <ul class="dropdown-menu" data-toggle="collapse" data-target="#navbar-collapse-1">
            <li style="border-bottom: 1px solid #fff"><a href="/#/chain"> Block Summary </a></li>
            <li><a href="/#/blocks"> All Blocks </a></li>
            <li><a href="/#/uncleblocks"> Uncle Blocks </a></li>
            <li><a href="/#/pendingTX"> Pending Txs </a></li>
            <li><a href="/#/txs"> All Txs </a></li>
            <li><a href="/#/topminers">Top Miners</a></li>
          </ul>
        </li>
        <li class="dropdown token">
          <a>
            CEC Token <b class="caret"></b>
            <div class="tab"></div>
          </a>
          <ul class="dropdown-menu" data-toggle="collapse" data-target="#navbar-collapse-1">
            <li><a href="/#/tokens"> CEC Tokens </a></li>
            <li><a href="/#/tokenTransfers"> CEC Token Transfers </a></li>
            <li>
              <div class="info">
                <span class="glyphicon glyphicon-info-sign"></span><br>
                CEC stands for Cortex Eco-Coin, it is a technical standard used for smart contracts on
                the Cortex blockchain for implementing tokens.
              </div>
            </li>
          </ul>
        </li>
        <li class="dropdown">
          <a>
            AI Contract <b class="caret"></b>
            <div class="tab"></div>
          </a>
          <ul class="dropdown-menu" data-toggle="collapse" data-target="#navbar-collapse-1">
            <li><a href="/upload/?"> Upload </a></li>
            <li style="border-bottom: 1px solid #fff"><a href="/upload/#/call"> Inference </a></li>
            <li><a href="/#/model"> Model List </a></li>
            <li><a href="/#/inputs"> Data List </a></li>
          </ul>
        </li>
        <li>
          <a href="/testnettoken" data-toggle="collapse" data-target="#navbar-collapse-1">
            Test Coin
            <div class="tab"></div>
          </a>
        </li>
      </ul>
      <button class="btn glyphicon glyphicon-search glyphicon-search1" onclick="openSearch()"></button>
      <form class="navbar-form" ng-submit="processRequest()"
            name="search_form" role="search" ng-show="ifSearch">
        <div class="mask" onclick="closeSearch()"></div>
        <button class="btn glyphicon glyphicon-search" onclick="processRequest()"></button>
        <input id="search-text" type="text" placeholder="Tx Hash, Address, or Block #"
               required autocomplete="off" class="form-control searchi">
      </form>
    </div>
  </div>
</nav>
<div class="front-screen slidepad">
  <div class="container-fluid">
      <h1 class='front-screen-title'>Get Cortex Test Coin</h1>
  </div>
</div>
<div class="slidepad content-box">
  <div class="container-fluid" v-bind:style="{minHeight: height - footer - screen + 'px'}">
    <div style="color: #000">
      <h2>Two ways to purchsae 1500 test net CTXC for 1 CTXC (ERC20).</h2>
      <ul>
        <li>Method one: use MetaMask on a desktop.</li>
        <li>Method two: imToken 2.0 or above. Activate DApp compatible mode, pay using imToken through the link.</li>
      </ul>
    </div>
    <div class="btn-group">
        <input v-if="step==1" v-model="spender_address" id="name" type="text" placeholder="Address">
        <button class="btn btn-all" @click="triggle" :disabled="pending">
          <template v-if="step==0">
          Approve <b> 1 CTXC </b> for Joining <i> Cortex Testnet </i>
          </template>
          <template v-else-if="step==1">
          Get Your Token on <i> Cortex Testnet </i>
          </template>
          <template v-else>
          Back
          </template>
        </button>
    </div>
  </div>
</div>
<div class="ifMeta" v-show="ifMetamask">
  <div class="ifMeta-box">
    <span style="float: right;cursor: pointer;line-height: 1;margin: 15px;" @click="ifMetamask = false"><i class="fa fa-times" aria-hidden="true"></i></span>
    <h2>Tips</h2>
    <p>Please make sure you have <a href="https://metamask.io/">installed</a> and logged into MetaMask!</p>
  </div>
</div>
<div class="footer styledfoot">
  <div>
    <p style="margin-bottom: 30px">
      <a href="https://github.com/CortexFoundation" target="_blank" class='footer-icon'
         style="background-position: 0 0"></a>
      <a href="https://www.facebook.com/CTXCBlockchain" target="_blank" class='footer-icon'
         style="background-position: -30px 0"></a>
      <a href="https://twitter.com/CTXCBlockchain" target="_blank" class='footer-icon'
         style="background-position: -60px 0"></a>
      <a href="https://t.me/CortexOfficialEN/" target="_blank" class='footer-icon'
         style="background-position: -90px 0"></a>
      <a href="https://www.reddit.com/r/Cortex_Official/" target="_blank" class='footer-icon'
         style="background-position: -120px 0"></a>
      <a href="mailto:testnet@cortexlabs.ai" target="_blank" class='footer-icon'
         style="background-position: -150px 0"></a>
    </p>
    <p>&copy; 2018 Cortexlabs.ai</p>
  </div>
</div>
</div>
</template>

<script>
import abi from "./abi.js"
const testnet_address = "0x0dbc8e0180f023dee7651b1124260fab8453ecb4";
const cortex_erc20_address = "0xEa11755Ae41D889CeEc39A63E6FF75a02Bc1C00d";

const BN = Web3.utils.BN;
const _1ctxc = new BN("1000000000000000000");

export default {
  name: 'App',
  data() {
    return {
      step: 0,
      pending: true,
      spender_address: "",
      own_address: "",
      height: window.innerHeight,
      footer: 0,
      screen: 0,
      ifMetamask: false,
    }
  },
  async mounted() {
    this.footer = document.getElementsByClassName('footer')[0].offsetHeight;
    this.screen = document.getElementsByClassName('front-screen')[0].offsetHeight;
    if (window.ethereum) {
      window.ethereum.enable().then(accounts => {
        this.web3 = new Web3(window.ethereum);
        this.own_address = web3.eth.defaultAccount;
        this.spender_address = window.web3.eth.defaultAccount;
        this.contract = new this.web3.eth.Contract(abi.CortexTestnet, testnet_address);
        this.token = new this.web3.eth.Contract(abi.ERC20Interface, cortex_erc20_address);
        this.pending = false;
      });
    } else {
      this.ifMetamask = true;
    }
  },
  methods: {
    async triggle() {
      if (this.step == 0) {
        this.pending = true;
        console.log(this.own_address);
        await this.token.methods.approve(testnet_address, _1ctxc.toString()).send(
          { from: this.own_address }
        );
        this.pending = false;
        this.step += 1;
      } else if (this.step == 1) {
        this.pending = true;
        await this.contract.methods.applyTestnetToken(this.spender_address).send(
          { from: this.own_address }
        );
        this.pending = false;
        this.step += 1;
      } else {
        this.step = 0;
      }
    }
  },
}
</script>

<style>
#app {
  position: relative;
}

.btn-group {
  margin: 20px auto;
}

.ifMeta {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0,0,0,0.5);
  z-index: 999
}

.ifMeta-box {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 50%;
  min-width: 300px;
  height: 200px;
  background: #fff;
  transform: translate(-50%,-50%);
  text-align: center;
  color: #000;
  line-height: 100px;
  font-size: 20px;
}

.navbar {
  position: absolute;
  top: 0;
  width: 100%;
}

.loading {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 1);
}

.load {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -150px;
  margin-left: -150px;
  width: 300px;
  height: 300px;
}

.yuan {
  position: absolute;
  animation: yuan 2s infinite linear;
  -webkit-animation: yuan 2s infinite linear;
}

@keyframes yuan {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.styledfoot {
  position: relative;
  width: 100%;
  height: 200px;
  text-align: center;
  color: #e6e6e6;
  background: #1a1a1a;
}

.styledfoot div {
  position: absolute;
  width: 100%;
  top: 50%;
  margin-top: -43px;
}

.styledfoot p {
  margin: 0;
}

.footer-icon {
  display: inline-block;
  margin: 0 15px;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  background: #fff url("./assets/foot-icon.png") no-repeat;
  background-size: 215px 30px;
}

.footer-icon:hover {
  background-color: #5ac0db;
}

/*@font-face {*/
  /*font-family: 'GothamPro';*/
  /*src: url('./GothamPro/GothamPro.eot?') format('eot'),*/
  /*url('./GothamPro/GothamPro.otf') format('opentype'),*/
  /*url('./GothamPro/GothamPro.woff') format('woff'),*/
  /*url('./GothamPro/GothamPro.ttf') format('truetype'),*/
  /*url('./GothamPro/GothamPro.svg') format('svg');*/
  /*font-weight: normal;*/
  /*font-style: normal;*/
/*}*/

body {
  /*font-family: GothamPro !important;*/
  position: relative;
  color: #fff;
}

a {
  color: #1a9cb5;
  text-decoration: none !important;
}

a:hover {
  color: #5ac0db;
}

.container-fluid {
  max-width: 1600px;
  margin: 0 auto;
}

.slidepad {
  padding-left: 100px;
  padding-right: 100px;
}

.content-box .container-fluid {
  padding-top: 30px;
  padding-bottom: 30px;
  color: #1a1a1a;
}

.navbar {
  border: none;
}

.container-fluid > .navbar-collapse {
  margin-left: 0;
  margin-right: 0;
}

.icon-bar {
  background-color: #fff;
}

.nav > li > a {
  font-size: 16px;
  color: #e6e6e6;
  background: transparent !important;
  outline: none !important;
  cursor: pointer;
  transition: color 0.5s;
}

.nav > li > a:hover {
  color: #5ac0db;
}

.navbar-nav > li:hover .tab {
  width: 100%;
}

.navbar-form {
  margin: 0;
  padding: 10px 0;
  position: relative;
}

.form-control {
  position: relative;
  background: #1a1a1a;
  border: 1px solid #999 !important;
  color: #fff;
  width: 100% !important;
  box-shadow: none !important;
  border-radius: 3px;
}

.glyphicon-search {
  border: none;
  outline: none !important;
  color: #fff !important;
  background: transparent;
}

.navbar-form .glyphicon-search {
  position: absolute;
  top: 7px;
  right: 12px;
  z-index: 2;
  color: #999 !important;
}

@media (min-width: 768px) {
  .container-fluid > .navbar-collapse {
    margin-left: 162px;
  }

  .navbar-nav {
    float: none;
    padding-right: 35px;
  }

  .navbar-nav li {
    width: 20%;
    text-align: center;
  }

  .nav > li > a {
    padding: 35px 15px 15px;
    line-height: 30px;
  }

  .tab {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0;
    height: 3px;
    background: #5ac0db;
    transition: width 0.5s;
  }

  .navbar-header .navbar-brand {
    padding: 30px 15px 40px;
    margin: 0 auto;
    height: 30px;
    box-sizing: content-box;
  }

  .glyphicon-search {
    position: absolute;
    top: 40px;
    right: 27px;
    width: 20px;
    padding: 0;
  }

  .navbar-form {
    position: absolute;
    left: 162px;
    right: 15px;
    top: 32px;
    display: none;
    padding: 0;
  }

  .mask {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: transparent;
  }
}

.dropdown-menu {
  position: static;
  padding: 0;
  width: 100%;
  border: none;
  box-shadow: none;
  background: #000;
}

.dropdown-menu > li {
  width: 100%;
}

.dropdown-menu > li > a {
  display: block;
  padding: 10px;
  color: #e6e6e6;
  text-align: center;
}

.dropdown:hover .dropdown-menu {
  display: block;
}

.dropdown-menu > li > a:focus, .dropdown-menu > li > a:hover {
  background: #5ac0db;
}



.front-screen {
  padding-top: 100px;
  color: #e6e6e6;
  background: #1a1a1a;
}

h1.front-screen-title {
  margin: 20px 0;
  font-size: 36px;
  text-transform: uppercase;
}

.btn-all, .btn-all:focus {
  color: #f2f2f2 !important;
  background: #5ac0db;
  border: none;
  outline: none !important;
  min-width: 80px;
}

.btn-all:hover {
  background: #75d9ef;
}

.btn-all-red, .btn-all-red:focus {
  color: #f2f2f2 !important;
  background: #D53451;
}

.btn-all-red:hover {
  background: #E83453;
}

.pages {
  text-align: center;
}

.pages .btn-all {
  min-width: 3em;
}

.pages-input {
  height: 18px;
  outline: none;
  border: 1px solid #ccc;
  background: #fff;
}

.table > tbody > tr > td, .table > tbody > tr > th, .table > tfoot > tr > td, .table > tfoot > tr > th, .table > thead > tr > td, .table > thead > tr > th {
  vertical-align: middle;
  border: none;
}

.table > thead > tr > th {
  color: #fff;
  background: #1a1a1a;
}

.table-striped > tbody > tr:nth-of-type(odd) {
  background: #fff;
}

.table-striped > tbody > tr:nth-of-type(even) {
  background: #ededed;
}

.form-control:focus {
  border-color: #5ac0db;
}

.info {
  padding: 5px;
  margin: 0 -50px;
  text-align: left !important;
  background: #000;
  border: 1px solid #f2f2f2;
  border-radius: 4px;
}

@media (max-width: 1200px) {
  .slidepad {
    padding-left: 0;
    padding-right: 0;
  }
}

@media (max-width: 768px) {
  .navbar {
    background: #000;
  }

  .navbar-brand {
    padding: 10px 15px;
  }

  .front-screen {
    padding-top: 50px;
  }

  .styledfoot {
    height: 150px;
  }

  .nav > li {
    overflow: hidden;
  }

  .info {
    padding: 10px 15px;
    margin: 0;
  }

  .glyphicon-search1 {
    display: none;
  }

  .navbar-form .glyphicon-search {
    top: 11px;
    right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue